import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function SectionHeader({ eyebrow, title, description, cta, ctaTo, align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl mb-12 ${alignCls}`}>
      {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.08]">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-slate-600 text-base leading-relaxed">{description}</p>
      )}
      {cta && ctaTo && (
        <Link to={ctaTo} className="inline-block mt-6">
          <Button variant="outline" className="h-11 px-5 border-slate-300 hover:border-slate-900 rounded-md">
            {cta} <ArrowRight className="w-4 h-4 ml-2" strokeWidth={1.75} />
          </Button>
        </Link>
      )}
    </div>
  );
}
